import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';

function initImpactSwipers() {
    document.querySelectorAll('.swiper--auto').forEach((swiperEl) => {

        const nextEl = swiperEl.querySelector('.swiper__next');
        const prevEl = swiperEl.querySelector('.swiper__prev');
        const paginationEl = swiperEl.querySelector('.swiper__pagination-inner');
        const progressBar = swiperEl.querySelector('.swiper__progress-bar');

        new Swiper(swiperEl, {
            modules: [Navigation, Pagination, EffectFade, Autoplay],

            loop: true,
            speed: 800,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },

            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },

            navigation: {
                nextEl,
                prevEl,
            },

            pagination: {
                el: paginationEl,
                type: 'fraction',
                formatFractionCurrent: (number) => {
                    return number < 10 ? `0${number}` : number;
                },
                formatFractionTotal: (number) => {
                    return number < 10 ? `0${number}` : number;
                },
                renderFraction(currentClass, totalClass) {
                    return `
                        <span class="${currentClass}"></span>
                        <span>-</span>
                        <span class="${totalClass}"></span>
                    `;
                },
            },

            on: {
                init(swiper) {
                    const progressBar = swiper.el.querySelector('.swiper__progress-bar');

                    if (!progressBar) return;

                    const realSlidesCount = swiper.slides.filter(
                        slide => !slide.classList.contains('swiper-slide-duplicate')
                    ).length;

                    if (realSlidesCount <= 1) {
                        progressBar.parentElement.style.display = 'none';
                    }
                },

                autoplayTimeLeft(swiper, time, progress) {
                    const progressBar = swiper.el.querySelector('.swiper__progress-bar');
                    if (!progressBar) return;

                    progressBar.style.transform = `scaleX(${1 - progress})`;
                },
            },
        });
    });
}

function mobileSwiper() {
    const alternateSwiper = new Swiper('.swiper--alt', {

        slidesPerView: 1.3,
        spaceBetween: 20,
        centeredSlides: false,

        // navigation: {
        //     nextEl: '.swiper__next',
        //     prevEl: '.swiper__prev',
        // },

        on: {
            init: updateProgress,
            slideChange: updateProgress,
        },
    });

    function updateProgress(swiper) {
        const bar = swiper.el.querySelector('.swiper__progress-bar');
        if (!bar) return;

        bar.style.transform = `scaleX(${(swiper.realIndex + 1) / swiper.slides.length})`;
    }
}

function testimonySwiper() {
    const alternateSwiper = new Swiper('.swiper--review', {
        modules: [Navigation],

        slidesPerView: 1.5,
        spaceBetween: 32,
        centeredSlides: false,
        watchOverflow: false,

        breakpoints: {
            // 768: {
            //     slidesPerView: 1.2,
            //     spaceBetween: 32,
            // },
            1024: {
                slidesPerView: 4,
                spaceBetween: 96,
            },
        },

        navigation: {
            nextEl: '.swiper__next--large',
            prevEl: '.swiper__prev--large',
        },

        on: {
            init: updateProgress,
            slideChange: updateProgress,
        },
    });

    function updateProgress(swiper) {
        const bar = swiper.el.querySelector('.swiper__progress-bar--black');
        if (!bar) return;

        const totalSteps = swiper.snapGrid.length;
        const currentStep = swiper.snapIndex + 1;

        const progress = currentStep / totalSteps;

        bar.style.transform = `scaleX(${progress})`;
    }

}

document.addEventListener('DOMContentLoaded', 
    initImpactSwipers(),
    mobileSwiper(),
    // cardSwiper(),
    testimonySwiper()
);